import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import _ from "lodash";
import InputDatoTendinaGenerico from "./modificaProdotti/elementiPagina/InputDatoTendinaGenerico";
import apiUrl from "./Apiurl";
import Tema from "./impostazioni/Tema";
import stilePulsanti from "./interfaccia/stilePulsanti";
import InputDatoProdotto from "./modificaProdotti/elementiPagina/InputDatoProdotto";
import associaImmagineENomeANomeUtente from "./interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";
/* import stileGrid from "./interfaccia/stileGrid";
import { DataGrid } from '@mui/x-data-grid';
import Header from "./interfaccia/menu/Header"; */

function Impostazioni({ temaColori, setTemaColori, autenticazione }) {


 /*  const columns = [
    {
      field: 'Nomecognome',
      headerName: 'Nome',
      width: 170,
    },
    {
      field: 'Stato_Ordine',
      headerName: 'Stato',
      width: 100,
    },
    {
      field: 'nazione',
      headerName: 'Nazione',
      width: 100,
    },
    {
      field: 'Tipo',
      headerName: 'Tipo',
      width: 120,
    },
    {
      field: 'N_rif_PrestaShop',
      headerName: 'PS',
      width: 70,
    },
    {
      field: 'Market_Place',
      headerName: 'Marketplace',
      width: 120,
    },
    {
      field: 'Tot_imp_spedizione',
      headerName: 'tot.',
      width: 70,
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        return `${params.value.toLocaleString()} €`;
      }
    },
    {
      field: 'Tipo_di_pagamento',
      headerName: 'Tipo pagamento',
      width: 100,
    },
    {
      field: 'Reso',
      headerName: 'Reso',
      width: 60,
      renderCell: (params) => {
        if (params.value == null || params.value === 0) { return '' }
        else { return <div class="rowitem material-icons md-13 scrittaColScuro">done</div> }
      }
    },
    {
      field: 'Promemoria',
      headerName: 'Prom',
      width: 60,
      renderCell: (params) => {
        if (params.value == null || params.value === 0) { return '' }
        else { return <div class="rowitem material-icons md-13 scrittaRosso">error</div> }
      }
    },
    {
      field: 'Corriere',
      headerName: '🚚',
      width: 50,
    }
  ];
 */
  const {
    buttonClassesGreen
  } = stilePulsanti

const {pathImmagine} = associaImmagineENomeANomeUtente(autenticazione.username,autenticazione.username,300)

    const [userTemp, setUserTemp] = useState(autenticazione);
    const [salvato, setSalvato] = useState(true);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [alert, setAlert] = useState("");
    const [resultSalvataggio, setResultSalvataggio] = useState(false);
    const [alertSalvataggio, setAlertSalvataggio] = useState(false);

    useEffect(() => {
      const getUserMetadata = async () => {
          try {
              const accessToken = await getAccessTokenSilently();
              setToken(accessToken);
          } catch (e) {
              console.log(e.message);
          }
      };
      getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  const handleChange = async function (evt) {
      setSalvato(false);
      const value = evt.target.value;
      try {
          if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
              const update = _.set(_.cloneDeep(userTemp), evt.target.name, value) // METODO RESOURCE EXPENSIVE
              setUserTemp(update)
          } else if (!evt.target.name.includes(".") && !evt.target.name.includes("[")) {
              setUserTemp({
                  ...userTemp,
                  [evt.target.name]: value
              });
          } else {
              setAlert("Errore cambio dato")
          }
      } catch (err) {
          console.log("Errore nell'aggiornamento di un dato nestato: " + err)
          throw err;
      }
  }

  const handleChangeTema = async function (nomeTema) {
    setSalvato(false);
    setTemaColori(nomeTema)
    try {
      setUserTemp({
        ...userTemp,
        tema: nomeTema
    });
    } catch (err) {
        console.log("Errore nell'aggiornamento di un dato nestato: " + err)
        throw err;
    }
}

  async function salvaProdotto(e) {
    e.preventDefault();
    if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    try {
        const data = {
            impostazioni: userTemp,
            utente: autenticazione
            /* utente: utente.username,
            permessi: utente.permessiAPI */
        }
        const config = {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }
        axios.patch(apiUrl + "/auth/impostazioni/salvaUtente", data, config)
            .then((resp) => {
                if (resp.data.errno) {
                    setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                } else {
                    setAlertSalvataggio(false)
                    setResultSalvataggio(resp.data)
                    setSalvato(true);
                }
            })
    } catch (err) {
        console.log("Errore nell'invio del prodotto alle API': " + err)
        throw err;
    }
}

  return (
    <div className="flex justify-center items-center">
        <div className="colonnaTuttaPagina w-30 ml4 mb5 sfondoBiancoTema pa4 sezioneConScroll bordoAngoloBassoSX ">
          <h3>Scelta tema</h3>
          <Tema
            nomeTema="rootTema"
            labelTema="Default"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="wavy"
            labelTema="Brufecod"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="vik"
            labelTema="Oki"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="temaGiallo"
            labelTema="Aspirina"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="tropicalFruitPunch"
            labelTema="Nux Vomica"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />          
          <Tema
            nomeTema="miscXXXI"
            labelTema="Aspirina C"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="temaVintage"
            labelTema="Novalgina"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="scuroGruvbox"
            labelTema="Tachifene"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="scuroMakan"
            labelTema="Tachidol"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="scuroTotale"
            labelTema="Zerinol"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          <Tema
            nomeTema="blu2"
            labelTema="Efferalgan"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          />
          {/* <Tema
            nomeTema="hilleBrand"
            labelTema="HilleBrand"
            temaColoriAttuale={temaColori}
            setTemaColori={handleChangeTema}
            autenticazione={autenticazione}
          /> */}
          



        </div>
        <div className="w-30 colonnaTuttaPagina mb5 sfondoBiancoTema pa4 bordoAngoloBassoDX">
        
        <div className="flex items-center">
        <div>

        
        <div className="w5 mb3 relative">
        <img
                  src={pathImmagine}
                  className="br-100 h-100 dib"
                  alt="foto utente"></img>
                  <div className="absolute nonSelezionabile pointer bottom-0 right-0">
          <a href="https://gravatar.com/profile/setup" target="_blank" rel="noopener noreferrer" className="br-100 sfondoColScuro pa3 tooltip">
            <div className="material-icons">edit</div>
            <div className="w5 tooltiptext">
        Per cambiare l'immagine del profilo vai su Gravatar, anche da cellulare, e loggati con la stessa mail che usi qui.
        </div>
          </a>
          
        </div>
        </div>
        
        {/*  */}
        
        </div>
        
        <div className="b f2 pl3">
          {userTemp.nomeDisplay}
        </div>
        </div>
        
        <div className="w-100 mt4">
        <InputDatoProdotto
                    inputLabel="Nome"
                    datoName='nomeDisplay'
                    datoId="nomeDisplay"
                    datoValue={userTemp.nomeDisplay ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={stilePulsanti.inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-100"}
                    classiTastoSblocco={stilePulsanti.classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={autenticazione.permessiAPI["read:database"] ? "SI" : "NO"}
                    />
        <InputDatoProdotto
                    inputLabel="Abbreviazione"
                    datoName='nickname'
                    datoId="nickname"
                    datoValue={userTemp.nickname ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={stilePulsanti.inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-100"}
                    classiTastoSblocco={stilePulsanti.classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={autenticazione.permessiAPI["read:database"] ? "SI" : "NO"}
                    />
        </div>
        <InputDatoTendinaGenerico
                    inputLabel="HomePage"
                    datoName={"home"}
                    elencoDati={["ordini","pubblicazione","check sparati"]}
                    datoId="home"
                    datoValue={userTemp.home ?? ''}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={stilePulsanti.inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-100"}
                    classiTastoSblocco={stilePulsanti.classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={autenticazione.permessiAPI["read:database"] ? "SI" : "NO"}
                />
        <InputDatoTendinaGenerico
                    inputLabel="Editor di testo preferito"
                    datoName={"textEditor"}
                    elencoDati={["tinyMCE","quill","sun"]}
                    datoId="textEditor"
                    datoValue={userTemp.textEditor ?? ''}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={stilePulsanti.inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-100"}
                    classiTastoSblocco={stilePulsanti.classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={autenticazione.permessiAPI["read:database"] ? "SI" : "NO"}
                />
        
        
        <div className="tc mt4">
        {salvato ? <p className="scrittaVerde b pa4">Impostazioni salvate</p> : <button className={buttonClassesGreen + " mb2"} onClick={salvaProdotto}>Salva e chiudi</button>}
        {alert}
        {resultSalvataggio && <pre className=''>{JSON.stringify(resultSalvataggio, null, 2)}</pre>}
        {alertSalvataggio && alertSalvataggio}
        </div>
        </div>
    </div>
  )
}

export default Impostazioni;